import SearchDocList from "./SearchDocList";

export default SearchDocList;